'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Vegetable Serve information
 */
var FruitServe = function (_Component) {
  (0, _inherits3.default)(FruitServe, _Component);

  function FruitServe() {
    (0, _classCallCheck3.default)(this, FruitServe);
    return (0, _possibleConstructorReturn3.default)(this, (FruitServe.__proto__ || (0, _getPrototypeOf2.default)(FruitServe)).apply(this, arguments));
  }

  (0, _createClass3.default)(FruitServe, [{
    key: 'render',
    value: function render() {
      var fruitServe = require('../Assets/fruitserve.png');
      var fruitHandServe = require('../Assets/fruithandserve.png');
      var styles = require('../../Modules.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 6 },
          _react2.default.createElement(
            'strong',
            null,
            'One serve of fruit (150g) is equivalent to:'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '1 medium apple, banana, orange, pear'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '2 small apricots, kiwi fruits or plums'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '1 cup of diced or canned fruit (no added sugar)'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Occasionally: 125ml (1/2 cup) fruit juice (no added sugar) or 30g dried fruit e.g. 4 dried apricot halves'
              )
            )
          ),
          _react2.default.createElement(ReactBootstrap.Image, { src: fruitHandServe, responsive: true, className: 'center-block' })
        ),
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 6 },
          _react2.default.createElement(
            'strong',
            { className: styles.orangeText },
            'Choose fruit juice less often'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Although fruit juice contains nutrients like vitamin C, folate, and some antioxidants, most naturally contain high amounts of sugar and kilojoules.'
          ),
          _react2.default.createElement(
            'p',
            { className: styles.orangeText },
            '1 cup of orange juice has close to 2.5 times the sugar and just one-third the fibre of a piece of fruit.'
          ),
          _react2.default.createElement(ReactBootstrap.Image, { src: fruitServe, responsive: true, className: 'center-block' })
        )
      );
    }
  }]);
  return FruitServe;
}(_react.Component);

exports.default = FruitServe;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ServeInformation/FruitServe/FruitServe.js
// module id = 1265
// module chunks = 0